export default __webpack_public_path__ + "static/media/backward_btn_icon.f31a051c.svg";